// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeviceItem__container-de24ff {
  flex: 1;
  display: flex;
  padding: 12px 24px;
}

.DeviceItem__icon-c702c7 {
  margin-inline-end: 24px;
  fill: var(--base-80);
}

.DeviceItem__device-info-f52cbc {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.DeviceItem__device-name-bb923e {
  font: var(--font-body-3);
  letter-spacing: var(--font-spacing-body-6);
  color: var(--base-110);
}

.DeviceItem__device-client-fa1e7e {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}

.DeviceItem__sessionInfo-fa54c7 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Device/DeviceItem/DeviceItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  padding: 12px 24px;\n}\n\n.icon {\n  margin-inline-end: 24px;\n  fill: var(--base-80);\n}\n\n.device-info {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n.device-name {\n  font: var(--font-body-3);\n  letter-spacing: var(--font-spacing-body-6);\n  color: var(--base-110);\n}\n\n.device-client {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n}\n\n.sessionInfo {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeviceItem__container-de24ff`,
	"icon": `DeviceItem__icon-c702c7`,
	"device-info": `DeviceItem__device-info-f52cbc`,
	"deviceInfo": `DeviceItem__device-info-f52cbc`,
	"device-name": `DeviceItem__device-name-bb923e`,
	"deviceName": `DeviceItem__device-name-bb923e`,
	"device-client": `DeviceItem__device-client-fa1e7e`,
	"deviceClient": `DeviceItem__device-client-fa1e7e`,
	"sessionInfo": `DeviceItem__sessionInfo-fa54c7`
};
module.exports = ___CSS_LOADER_EXPORT___;
